module.exports = __webpack_public_path__ + "img/ssyx_12.4a9e55eb.jpg";